import { cn } from '@/lib/utils';

import { AdditionalSVGProps } from '@/models/Svg';

export const TwitterIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='29'
        height='27'
        viewBox='0 0 29 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={cn(`fill-[${fill}]`, className)}
        {...rest}
      >
        <path d='M22.8375 0.359375H27.2854L17.5704 11.4918L29 26.6406H20.0517L13.0428 17.4513L5.02244 26.6406H0.57275L10.9638 14.7325L0 0.359375H9.17669L15.5114 8.75669L22.8375 0.359375ZM21.2787 23.9726H23.7438L7.83544 2.88781H5.19281L21.2787 23.9726Z' />
      </svg>
    </>
  );
};
